import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import DepositInvoiceDetailContent from './content';
import './index.scss';
import { t } from 'i18next';
function DetailDialog({ data, modalOpen, onToggle }) {
  return (
    <Modal isOpen={modalOpen} size='lg' backdrop={true} style={{ top: '1%' }}>
      <div className=' modal-header' style={{ background: '#e9e9ef' }}>
        <h5 className=' modal-title'>{t('deposit_invoice.deposit_invoice')}</h5>
        <button aria-label='Close' className=' close' type='button' onClick={() => onToggle(!modalOpen)}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>

      <ModalBody className='order-detail-dialog'>
        <DepositInvoiceDetailContent data={data} />
      </ModalBody>
    </Modal>
  );
}
export default DetailDialog;
